import React, {Component} from "react";
import {getTableConfigDaily} from "../config";
import FlexView from "react-flexview";
import * as R from "ramda";
import Api from "../../../../../Services/Api";
import {mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {fetchDataAsync, FormatCurrencyWithoutSymbol} from "../../../../../Services/Utils";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import {HttpStatus} from "../../../../common/Constants";

class DailyMonitoring extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataTableIn: [],
            dataTableOut: [],
            tableConfig: [],
            codeOptions: [],
            selectedCode: null,
            beginningBalance: 0,
            finalBalance: 0,
            totalBelumRealisasiMasuk: 0,
            totalRealisasiMasuk: 0,
            totalBelumRealisasiKeluar: 0,
            totalRealisasiKeluar: 0,
            paginationIn: {
                totalData: 0,
                limit: 5,
                page: 1,
            },
            paginationOut: {
                totalData: 0,
                limit: 5,
                page: 1,
            },
        };
    };

    async componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: getTableConfigDaily(this.props.tab),
        }));
        if (!R.isNil(this.props.kodeCabang)) {
            console.log("here, change tab");
            this.props.triggerLoading();
            await this.fetchCodeOptions();
            this.props.triggerLoading();
        }
    };

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(this.props.kodeCabang, prevProps.kodeCabang)) {
            this.setState((prevValue) => ({
                ...prevValue,
                codeOptions: [],
                selectedCode: null,
                dataTableIn: [],
                dataTableOut: [],
                paginationIn: {totalData: 0, page: 1, limit: 5},
                paginationOut: {totalData: 0, page: 1, limit: 5},
                beginningBalance: 0,
                finalBalance: 0,
                totalBelumRealisasiMasuk: 0,
                totalRealisasiMasuk: 0,
                totalBelumRealisasiKeluar: 0,
                totalRealisasiKeluar: 0,
            }));
            this.props.triggerLoading();
            await this.fetchCodeOptions();
            this.props.triggerLoading();
        }

        if (prevState.paginationIn.page !== this.state.paginationIn.page ||
            prevState.paginationIn.limit !== this.state.paginationIn.limit
        ) {
            await this.fetchData("IN");
        }

        if (prevState.paginationOut.page !== this.state.paginationOut.page ||
            prevState.paginationOut.limit !== this.state.paginationOut.limit
        ) {
            await this.fetchData("OUT");
        }
    };

    fetchCodeOptions = async () => {
        try {
            if (this.props.tab === "cash") {
                const response = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterKas,
                    setError: this.props.setError,
                    menuName: "Dashboard Cashier - Monitoring Transaksi Kas Harian",
                    args: {paramFilters: {kodecabang: this.props.kodeCabang}},
                });
                if (response.ok && !R.isEmpty(response.data.data)) {
                    await this.setState((prevValue) => ({
                        ...prevValue,
                        codeOptions: response.data.data.map(item => mapToObjectDDL(item.name, item.kodeKas)),
                    }));
                } else if (response.ok && R.isEmpty(response.data.data)) {
                    await this.setState((prevValue) => ({
                        ...prevValue,
                        codeOptions: [],
                        selectedCode: null,
                    }));
                }
            } else if (this.props.tab === "bank") {
                const response = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank,
                    setError: this.props.setError,
                    menuName: "Dashboard Cashier - Monitoring Transaksi Bank Harian",
                    args: {paramFilters: {kodecabang: [this.props.kodeCabang]}},
                });
                if (response.ok && !R.isEmpty(response.data.data)) {
                    await this.setState((prevValue) => ({
                        ...prevValue,
                        codeOptions: response.data.data.map(item => mapToObjectDDL(item.bankName, item.accountNumber)),
                    }));
                } else if (response.ok && R.isEmpty(response.data.data)) {
                    await this.setState((prevValue) => ({
                        ...prevValue,
                        codeOptions: [],
                        selectedCode: null,
                    }));
                }
            }
        } catch (e) {
            console.log("errors:", e);
        }
    };

    handleChangePageIn = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            paginationIn: {
                ...prevValue.paginationIn,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPageIn = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            paginationIn: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleChangePageOut = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            paginationOut: {
                ...prevValue.paginationOut,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPageOut = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            paginationOut: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    fetchDataTotal = async () => {
        const req = removeNullFields({
            kodeCabang: this.props.kodeCabang,
            jenisTransaksi: this.props.tab.toUpperCase(),
            filter: this.state.selectedCode?.value,
        });
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT_DTO").getCashierTotal,
            menuName: this.props.tab === "cash"
                ? "Dashboard Cashier - Monitoring Transaksi Kas Harian"
                : "Dashboard Cashier - Monitoring Transaksi Bank Harian",
            setError: this.props.setError,
            args: req,
        });
        console.log("res", res.data);
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let {data} = res.data;
            console.log("total", data.saldoKasAkhir);
            this.setState((prevValue) => ({
                ...prevValue,
                beginningBalance: data.saldoKasAwal,
                finalBalance: data.saldoKasAkhir,
                totalBelumRealisasiMasuk: data.totalBelumRealisasiMasuk,
                totalRealisasiMasuk: data.totalRealisasiMasuk,
                totalBelumRealisasiKeluar: data.totalBelumRealisasiKeluar,
                totalRealisasiKeluar: data.totalRealisasiKeluar,
            }));
        }
    };

    fetchData = async (type) => {
        this.props.triggerLoading();
        let code = this.props.tab === "cash" ? "kodeKas" : "noRekening";
        const request = removeNullFields({
            kodeCabang: this.props.kodeCabang,
            [code]: this.state.selectedCode?.value,
            paymentType: type,
        });
        if (type === "OUT") {
            await this.fetchDataOut(request);
        }
        if (type === "IN") {
            await this.fetchDataIn(request);
        }
        this.props.triggerLoading();
    };

    fetchDataIn = async (req) => {
        let {tab} = this.props;
        let {paginationIn} = this.state;
        let asyncFn = tab === "cash"
            ? Api.create("NAGAMAS_REPORT_DTO").getCashierDailyCash
            : Api.create("NAGAMAS_REPORT_DTO").getCashierDailyBank;
        let res = await fetchDataAsync({
            asyncFn,
            menuName: tab === "cash"
                ? "Dashboard Cashier - Monitoring Transaksi Kas Harian"
                : "Dashboard Cashier - Monitoring Transaksi Bank Harian",
            setError: this.props.setError,
            args: {
                ...req,
                page: paginationIn.page,
                limit: paginationIn.limit,
            }
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            console.log("res", res.data.data)
            this.setState((prevValue) => ({
                ...prevValue,
                dataTableIn: res.data.data,
                paginationIn: {
                    ...prevValue.paginationIn,
                    totalData: res.data.totalData,
                }
            }));
        }
    };

    fetchDataOut = async (req) => {
        let {tab} = this.props;
        let {paginationOut} = this.state;
        let asyncFn = tab === "cash"
            ? Api.create("NAGAMAS_REPORT_DTO").getCashierDailyCash
            : Api.create("NAGAMAS_REPORT_DTO").getCashierDailyBank;
        let res = await fetchDataAsync({
            asyncFn,
            menuName: tab === "cash"
                ? "Dashboard Cashier - Monitoring Transaksi Kas Harian"
                : "Dashboard Cashier - Monitoring Transaksi Bank Harian",
            setError: this.props.setError,
            args: {
                ...req,
                page: paginationOut.page,
                limit: paginationOut.limit,
            }
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            console.log("res", res.data.data)
            this.setState((prevValue) => ({
                ...prevValue,
                dataTableOut: res.data.data,
                paginationOut: {
                    ...prevValue.paginationOut,
                    totalData: res.data.totalData,
                }
            }));
        }
    };

    handleChangeCode = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleClickSearch = async () => {
        await this.fetchData("OUT");
        await this.fetchData("IN");
        await this.fetchDataTotal();
    };

    render() {
        let {dataTableIn, dataTableOut, paginationIn, paginationOut, tableConfig} = this.state;
        let {tab} = this.props;
        return (
            <>
                <FlexView style={{alignItems: "center", marginBottom: "15px"}}>
                    <SimpleDDL
                        name="selectedCode"
                        box="search"
                        isClearable
                        label={this.props.tab === "cash" ? "Kode Kas" : this.props.tab === "bank" ? "Kode Bank" : ""}
                        containerclassname="width width-300px"
                        options={this.state.codeOptions}
                        value={this.state.selectedCode}
                        onChange={(value, {name}) => this.handleChangeCode(name, value)}
                    />
                    <SimpleButton styles={{marginTop: "5px"}} onClick={this.handleClickSearch}>Cari</SimpleButton>
                </FlexView>
                <div className="grid grid-2x gap-20px margin-bottom-15px">
                    <div id="grid-1">
                        <SimpleDataTable
                            columns={tableConfig[0]}
                            data={dataTableIn}
                            toCount={paginationIn.totalData}
                            rowsPerPage={paginationIn.limit}
                            page={paginationIn.page - 1}
                            options={defaultTableChange(this.handleChangePageIn, this.handleRowsPerPageIn)}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleDataTable
                            columns={tableConfig[1]}
                            data={dataTableOut}
                            toCount={paginationOut.totalData}
                            rowsPerPage={paginationOut.limit}
                            page={paginationOut.page - 1}
                            options={defaultTableChange(this.handleChangePageOut, this.handleRowsPerPageOut)}
                        />
                    </div>
                </div>
                <FlexView column style={{marginTop: "15px"}}>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Total ${tab === "cash" ? "BKM" : "BBM"} Belum Realisasi    : ${FormatCurrencyWithoutSymbol({number: this.state.totalBelumRealisasiMasuk})}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Total ${tab === "cash" ? "BKM" : "BBM"} Sudah Realisasi    : ${FormatCurrencyWithoutSymbol({number: this.state.totalRealisasiMasuk})}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Total ${tab === "cash" ? "BKK" : "BBK"} Belum Realisasi    : ${FormatCurrencyWithoutSymbol({number: this.state.totalBelumRealisasiKeluar})}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Total ${tab === "cash" ? "BKK" : "BBK"} Sudah Realisasi    : ${FormatCurrencyWithoutSymbol({number: this.state.totalRealisasiKeluar})}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Saldo ${this.props.tab === "cash" ? "Kas" : "Bank"} Awal   : Rp. ${FormatCurrencyWithoutSymbol({number: this.state.beginningBalance})}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Saldo ${this.props.tab === "cash" ? "Kas" : "Bank"} Akhir  : Rp. ${FormatCurrencyWithoutSymbol({number: this.state.finalBalance})}`}
                    </p>
                </FlexView>
            </>
        )
            ;
    };
}

export default DailyMonitoring;